import React from 'react';
import CloseIcon from '../../../assests/img/close-icon-grey.svg?react';
import SortByIcon from '../../../assests/img/sort-by-icon.svg?react';
import SortByDescIcon from '../../../assests/img/sort-by-desc-icon.svg?react';
import classNames from 'classnames';
import '../../../assests/css/sortby.scss';


export type sortByType = 'asc' | 'desc' | 'default';
interface sortByProps {
    sortType: sortByType,
    onClick: (sortType: sortByType) => void,
    onClear: () => void,
}

function SortBy(props: sortByProps) {
    const  {sortType, onClick, onClear} = props;

    const renderSortIcon = (sortType: sortByType) => {
        switch (sortType) {
          case 'asc':
            return (
              <div className={classNames('sort-icon active', sortType)}>
                <div
                  className='icon d-flex align-items-center justify-content-center'
                  onClick={() => onClick('desc')}
                >
                    <SortByDescIcon/>
                </div>
                <div
                  className='icon pe-1 d-flex align-items-center justify-content-center'
                  onClick={onClear}
                >
                    <CloseIcon
                      width='7px'
                      height='7px'
                      className='clear-sort-icon'
                    ></CloseIcon>
                </div>
              </div>
            );
          case 'desc':
            return (
              <div className={classNames('sort-icon active', sortType)}>
                <div
                  className='icon d-flex align-items-center justify-content-center'
                  onClick={() => onClick('asc')}
                >
                    <SortByDescIcon/>
                </div>
                <div
                  className='icon pe-1 d-flex align-items-center justify-content-center'
                  onClick={onClear}
                >
                    <CloseIcon
                      width='7px'
                      height='7px'
                      className='clear-sort-icon'
                    ></CloseIcon>
                </div>
              </div>
            );
          default:
            return (
              <div
                className='sort-icon d-flex align-items-center justify-content-center'
                onClick={() => onClick('asc')}
              >
                  <SortByIcon/>
              </div>
            );
        }
    };

    return renderSortIcon(sortType);
}

export default SortBy;
